import {
  GET_BANK_OPERATIONS,
  GET_BANK_OPERATIONS_COMPLETED,
  GET_BANK_OPERATIONS_FAILED,
} from "./actions";

const initialState = {
  import: null,
  stats: null,
  phases: [],
  familles: [],
  categories: [],
  operations: [],
  sheets: null,
  isLoading: false,
  isInitialized: false,
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_BANK_OPERATIONS:
      return { ...state, isLoading: true };
    case GET_BANK_OPERATIONS_COMPLETED: {
      // L'API bancaire enveloppe dans { code, result: {...} } : on déballe le
      // niveau interne (contrairement aux endpoints FOSRest des autres ducks).
      const p = action.payload.result || {};
      const r = p.result || p;
      return {
        ...state,
        import: r.import || null,
        stats: r.stats || null,
        phases: r.phases || [],
        familles: r.familles || [],
        categories: r.categories || [],
        operations: r.operations || [],
        sheets: r.sheets || null,
        isLoading: false,
        isInitialized: true,
      };
    }
    case GET_BANK_OPERATIONS_FAILED:
      return { ...state, isLoading: false, isInitialized: true };
    default:
      return state;
  }
};

export default reducers;
